<template>
    <li class="shadow">
        <div class="chat__contact flex items-center px-2 pt-4 pb-2"
            :class="{'bg-primary-gradient text-white shadow-lg' : isSelected}" 
            @click="$emit('selected', item)"
            @keydown.esc="editing = false" tabindex="1">
            <div class="contact__container w-full items-center justify-between overflow-hidden" >
                <div class="contact__info vx-row items-center truncate w-full">
                    <h5 
                        class="font-semibold mt-1 pl-8 w-10/12" 
                        :class="{'text-white' : isSelected}"> 
                            <a-icon type="menu"
                                v-show="!disableHandler"
                                class="mr-4 handle cursor-move"/>
                            <span class="mr-2 to-the-right">
                                <vue-mdi :icon="icon"
                                    :size="1" 
                                    :color="!isSelected ? '#d92323' : '#fff'"
                                  />
                            </span>
                            <span v-if="!editing" @dblclick="edit">
                                {{ isSelected ? item.description.toUpperCase() : item.description }} 
                            </span>
                            <div v-else class="inline-flex text-black">
                                <vs-input tabindex="0" ref="edit-desc" 
                                    v-model="editingDescription"
                                    :warning="invalidName"
                                    warning-text="Deve ter entre 2 e 50 caracteres"
                                    @blur="dispatch"
                                    @keydown.enter="saveEditing"
                                    @keydown.esc="editing = false"/>
                            </div>
                    </h5>
                </div>
            </div>

            <div v-show="allowEdit && !editing" class="w-2/12 text-right mr-2">
                <slot>
                    <a-button type="dashed" icon="edit"
                        @click="$emit('edit')"></a-button>
                </slot>
            </div>
            <div v-if="editing" class="inline-flex text-right mb-2 mr-2" @focus="editing = true" tabindex="3">
                <a-popconfirm placement="top" ok-text="Sim" cancel-text="Não" @confirm="$emit('deleteItem', item)"
                    @visibleChange="popupVisibleChanged">
                    <a-icon slot="icon" type="exclamation-circle-o" style="color: red" />
                    <template slot="title">
                        <b>Atenção!</b><br/>
                        <div class="mt-2">
                            Os produtos serão mantidos!<br/>
                            Remover o tipo de produto?
                        </div>
                    </template>
                    <a-button icon="delete" class="mr-2"></a-button>
                </a-popconfirm>
                
                <a-button icon="check"
                        @click="saveEditing"></a-button>
            </div>
        </div>
    </li>
</template>

<script>
    export default {
        props : {
            isSelected : {
                type : Boolean,
                required : false
            },
            item: Object,
            disableHandler: Boolean,
            allowEdit: Boolean,
        },

        watch: {
            item: {
                handler (val) {
                    this.editingDescription = val.description
                },
                deep: true,
                immediate: true
            }
        },

        data () {
            return {
                showRemove : false,
                editingDescription: '',
                editing: false,
                promptOpen: false,
                interval: null
            }
        },

        computed: {
            icon () {
                if (!this.item.icon)
                    return '';
                return this.item.icon.replace('mdi-', '');
            },
            invalidName () {
                return !this.editingDescription || this.editingDescription.length <= 1 || this.editingDescription.length >= 50;
            }
        },

        methods : {
            popupVisibleChanged (val) {
                this.promptOpen = val;
                this.dispatch();
            },
            dispatch () {
                clearInterval(this.interval);
                this.$nextTick(() => {
                    this.interval = setTimeout(() => {
                        if (!this.promptOpen) {
                            this.editing = false;
                            this.editingDescription = this.item.description;
                        }
                    }, 200);
                });
            },

            edit () {
                if (!this.allowEdit)
                    return
                this.editing = true;
                this.$emit('selected', this.item);
                this.$nextTick(() => {
                    try {
                        this.$refs['edit-desc'].focusInput();
                        this.$refs['edit-desc'].$refs['vsinput'].select(); // selects text
                    } catch (err) {
                        console.log('cannot focus on element', err);
                    }
                })
            },

            saveEditing () {
                const { editingDescription, item, invalidName } = this;
                if (!invalidName && editingDescription !== item.description)
                    this.$emit('saveEditing', editingDescription);
                else
                    this.editingDescription = item.description;
                this.editing = false;
            }
        },
    }
</script>
<style scoped>
    .to-the-right {
        position: absolute;
        right: 4px;
    }
</style>